export default __webpack_public_path__ + "static/media/check1.ea83f6f4.png";